import * as types from './leaver.types'

export const actions = {
	toggleLoading: payload => ({
		type: types.TOGGLE_LOADING,
		payload,
	}),
	toggleSuccess: payload => ({
		type: types.TOGGLE_SUCCESS,
		payload,
	}),
	set: payload => ({
		type: types.SET_LEAVER,
		payload,
	}),
	create: payload => ({
		type: types.CREATE_LEAVER,
		payload,
	}),
	get: payload => ({
		type: types.GET_LEAVER,
		payload,
	}),
	edit: payload => ({
		type: types.EDIT_LEAVER,
		payload,
	}),
	delete: payload => ({
		type: types.DELETE_LEAVER,
		payload,
	}),
	getOptions: () => ({
		type: types.GET_OPTIONS,
	}),
	setOptions: payload => ({
		type: types.SET_OPTIONS,
		payload,
	}),
	clearData: () => ({
		type: types.CLEAR_DATA,
	}),
	setPermissions: payload => ({
		type: types.SET_PERMISSIONS,
		payload,
	}),
}
